// Generated from src/img/svg/s8.svg

export const S8 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S8"
        style={{
          fill: "#ffcb00",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue",sans-serif',
          fontSize: "10px",
          fontWeight: "700",
          transform: "translate(.5px,0)",
        }}
      >
        <path d="M6.715 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M14.525 7.88q0 .53.36.86t.88.33.86-.33.34-.85q0-.49-.35-.8-.34-.32-.85-.32-.54 0-.88.28-.36.31-.36.83m-1.13-3.11q0-.89.75-1.43.68-.48 1.61-.48 1.17 0 1.82.68.52.55.52 1.2 0 1.12-1.02 1.49.62.14.96.6.35.45.35 1.11 0 1.04-.82 1.65-.74.55-1.8.55-1.1 0-1.84-.53-.82-.59-.82-1.66 0-.66.35-1.11.35-.46.97-.61v-.02q-1.03-.29-1.03-1.44m1.29.13q0 .44.31.68t.76.24.75-.24q.3-.25.3-.68 0-.37-.19-.62-.28-.35-.86-.35-.45 0-.76.26t-.31.71" />
      </g>
    </svg>
  );
};
